"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 25 25",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M5.382 9.2a3.029 3.029 0 0 1-2.945-2.33H.844a.694.694 0 0 1 0-1.387h1.593A3.029 3.029 0 0 1 5.382 3.15c1.408 0 2.627.973 2.946 2.332H23.74a.694.694 0 0 1 0 1.387H8.328A3.029 3.029 0 0 1 5.382 9.2Zm0-4.663a1.64 1.64 0 0 0-1.158 2.796A1.64 1.64 0 0 0 6.54 5.017a1.64 1.64 0 0 0-1.158-.48ZM16.11 15.228a3.18 3.18 0 0 0 1.924.65l-.001-.001a3.18 3.18 0 0 0 3.062-2.33h2.644a.845.845 0 0 0 0-1.69h-2.644a3.18 3.18 0 0 0-4.986-1.68 3.18 3.18 0 0 0-1.14 1.682H.845a.845.845 0 0 0 0 1.688H14.97a3.18 3.18 0 0 0 1.139 1.681Zm1.095-3.763a1.49 1.49 0 1 1 1.653 2.479 1.49 1.49 0 0 1-1.653-2.479ZM5.328 21.755a3.18 3.18 0 0 0 3.848 0 3.18 3.18 0 0 0 1.138-1.682H23.74a.845.845 0 0 0 0-1.688H10.314a3.18 3.18 0 0 0-4.986-1.681 3.18 3.18 0 0 0-1.139 1.68H.844a.845.845 0 0 0 0 1.69h3.345a3.18 3.18 0 0 0 1.139 1.68Zm1.095-3.763a1.49 1.49 0 1 1 1.653 2.48 1.49 1.49 0 0 1-1.653-2.48Z",
    clipRule: "evenodd"
  })]
});